import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=62bb4cd6&"
import script from "./FormModal.vue?vue&type=script&lang=js&"
export * from "./FormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62bb4cd6')) {
      api.createRecord('62bb4cd6', component.options)
    } else {
      api.reload('62bb4cd6', component.options)
    }
    module.hot.accept("./FormModal.vue?vue&type=template&id=62bb4cd6&", function () {
      api.rerender('62bb4cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Script/FormModal.vue"
export default component.exports